///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, ElementRef, EventEmitter, HostListener, Input, NgZone, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { isDefined } from '@siklu/sui-lib/utils';

@Directive({
    selector: '[windeAngleInputValidation]',
    providers: [{ provide: NG_VALIDATORS, useExisting: GtthAngleInputValidationDirective, multi: true }]
})
export class GtthAngleInputValidationDirective implements OnChanges, OnInit, Validator, OnDestroy {
    @Input() inputVal: any;
    @Input() angleMinMax: any;

    @Output() inputValChange: EventEmitter<number> = new EventEmitter<number>();

    private validationTimer;
    private validationTimeOut = 0;

    private readonly validationRule = /[^\d-]/gi;

    private pasteText: string;

    constructor(
        private readonly el: ElementRef,
        private readonly ngZone: NgZone
    ) {}

    ngOnChanges() {
        this.runValidation();
    }

    ngOnInit() {
        this.el.nativeElement.onpaste = (e) => {
            this.pasteText = e.clipboardData.getData('Text');
            this.runValidation();
        };
    }

    ngOnDestroy() {
        if (this.validationTimer) {
            clearTimeout(this.validationTimer);
            this.validationTimer = null;
        }
        this.validationTimeOut = null;
        this.pasteText = null;
    }

    validate(formControl: FormControl): Record<string, any> {
        const inpValue = formControl.value;
        if (!isDefined(inpValue)) {
            return { invalid: true };
        }

        let outOfRange = false;

        if (
            (this.angleMinMax.min < this.angleMinMax.max && (inpValue < this.angleMinMax.min || inpValue > this.angleMinMax.max)) ||
            (this.angleMinMax.min > this.angleMinMax.max && inpValue > this.angleMinMax.max && inpValue < this.angleMinMax.min)
        ) {
            outOfRange = true;
        }

        return outOfRange ? { outOfRange: true } : null;
    }

    private runValidation() {
        this.ngZone.runOutsideAngular(() => {
            this.validationTimer = setTimeout(() => {
                this.ngZone.run(() => {
                    this.customValidate();
                    this.inputValChange.emit(this.inputVal);
                });
            }, this.validationTimeOut);
        });
    }

    private customValidate() {
        if (!this.inputVal && this.inputVal !== 0 && this.pasteText) {
            this.inputVal = this.pasteText;
        }

        this.pasteText = undefined;

        if (isDefined(this.inputVal)) {
            let valueString = this.inputVal.toString();
            valueString = valueString.replace(this.validationRule, '');
            this.inputVal = parseInt(valueString, 10);
        }
    }

    @HostListener('keydown', ['$event'])
    OnKeydown(event): boolean | undefined {
        if (event.which === 69 || event.which === 107 || event.which === 187) {
            return false;
        }

        if (event.which === 109 || event.which === 189) {
            return false;
        }

        if (event.which === 110 || event.which === 190) {
            return false;
        }
    }
}
